import { render, staticRenderFns } from "./NuevoTelefono.vue?vue&type=template&id=7252acbe&scoped=true&"
import script from "./NuevoTelefono.vue?vue&type=script&lang=js&"
export * from "./NuevoTelefono.vue?vue&type=script&lang=js&"
import style0 from "./NuevoTelefono.vue?vue&type=style&index=0&id=7252acbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7252acbe",
  null
  
)

export default component.exports